import { firebaseDatabase } from '../../firebaseDb';


export default {

    state :{
        name : 'Detech Visitors',
        visited_dates : [],
        visited_dates_and_id : null,
        browser_agent : null
    },

    actions:{

        initDetechVisitors({dispatch,state}){

            // to day
            let to_day = new Date().toDateString();

            // get visited dates
            const visited_dates = JSON.parse(localStorage.getItem('date')) || [];

            // find today date from  visited dates then return condition
            const is_visited_today =  visited_dates.find((date) =>{
                return date.day == to_day
            });


            // generate random number and split it
            const randomNumber =  Math.random().toString().split('.');
            // pick up first index from randomNumber array
            // const visitor_generated__id = randomNumber[1];

            // get old visitor id
            const get_visitor_generated__id = localStorage.getItem('visitor_id');

            /*
            * is exist old visitor id
            * if old visitor id does not exist add id to localStorage
            */
            if(get_visitor_generated__id === null){
                localStorage.setItem('visitor_id',randomNumber[1]);
                //console.log('added to localStorage id with key visitor_id');
            }else {
               // console.log(get_visitor_generated__id);
            }


            //is not visited today
            if(!is_visited_today){

                visited_dates.push({
                    full_date : eval(new Date()),
                    day : to_day,
                });

                // reassign visited dates
                localStorage.setItem('date', JSON.stringify(visited_dates));

                const visited_dates_and_id = {
                    visitor_generated__id : localStorage.getItem('visitor_id'),
                    visited_dates: visited_dates
                };

                state.visited_dates_and_id = visited_dates_and_id;

                // dispatch to InitBrowserAgent
                dispatch('InitBrowserAgent');

                // dispatch to insertNewVisitor
                dispatch('insertNewVisitor');

            }else{
               // console.log('you are visited today !');
            }
        },


        async insertNewVisitor({state}){

            const visitor_generated__id = state.visited_dates_and_id.visitor_generated__id;

            const visited_dates = state.visited_dates_and_id.visited_dates;

            const browser_agent = state.browser_agent;


            //get user ip info
            let response = await fetch('https://ipapi.co/json/');
            // let response = await fetch('https://ipinfo.io/json');
            let user_ip_info = await response.json();


            // new visitor obj
            const newVisitor = {
                visitor_generated__id,visited_dates,browser_agent,user_ip_info
            };

            // call firebase api
            firebaseDatabase.collection('track_visitors').add(newVisitor)
                .then(()=> {
                    console.log('Success:');
                })
                .catch((err) => {
                    console.log(err);
                });
        },

         InitBrowserAgent({state}){

            // get browser name
            const browser  = (function() {
                const test = function(regexp) {return regexp.test(window.navigator.userAgent)};
                switch (true) {
                    case test(/edg/i): return "Microsoft Edge";
                    case test(/trident/i): return "Microsoft Internet Explorer";
                    case test(/firefox|fxios/i): return "Mozilla Firefox";
                    case test(/opr\//i): return "Opera";
                    case test(/ucbrowser/i): return "UC Browser";
                    case test(/samsungbrowser/i): return "Samsung Browser";
                    case test(/chrome|chromium|crios/i): return "Google Chrome";
                    case test(/safari/i): return "Apple Safari";
                    default: return "Other";
                }
            })();

            // get language
            const language  = navigator.language;
            // get platform
            const platform  = navigator.platform;

            // get access url
            const URL  = document.URL;

            // get innerWidth
            const innerWidth  = window.innerWidth;

            //get innerHeight
            const innerHeight  = window.innerHeight;

            state.browser_agent = {
                browser,language,platform,innerWidth,innerHeight,URL
            }
        }
    },
}

